class PISSegmentsController {
  constructor(stateService, toasterService, userService, $uibModal) {
    'ngInject';
    this.stateService = stateService;
    this.toasterService = toasterService;
    this.userService = userService;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    this.fetchSegments();
    this.editMode = false;
    this.modalOptions = {
      name: 'segment',
      fields: [
        { name: 'Name', key: 'name', type: 'row' },
        { name: 'Description', key: 'description', type: 'row' },
        { name: 'Stream Type', key: 'stream_type', type: 'row' },
      ]
    };
    this.hasEdit = this.userService.hasEditPIS();
  }

  fetchSegments() {
    this.stateService.getSegments().then(data => this.segments = data.filter(seg => seg.offline === false));
  }

  onToggleEdit(event) {
    this.editMode = event.editMode;
    this.selection = event.item;
  }

  onDelete(event) {
    this.stateService.deleteSegment(event.itemId).then(
      response => {
        this.fetchSegments();
        if (response.statusCode !== 404 && response.statusCode !== 500) {
          this.toasterService.success('toaster.pis-event', 'toaster.pis-delete-segment-successful');
        } else {
          this.toasterService.error('toaster.pis-event', 'toaster.pis-delete-segment-failure');
        }
      },
      function (e) {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.log(e);
      }
    );
  }

  onFormSubmit(event) {
    this.editMode = event.mode;
    this.fetchSegments();
    this.selection = null;
  }

  onFileUpload(event) {
    this.stateService.getSegments().then(data => {
      this.segments = data;
      this.selection = this.segments.find(segment => segment.id === event.current.id);
    });
  }

  toggleEditor() {
    if (this.editMode) {
      this.editMode = false;
      this.fetchSegments();
      this.selection = null;
    } else {
      this.editMode = true;
    }
  }

  openUploadModal() {
    const modalInstance = this.$uibModal.open({
      component: 'filesUploadModal',
      resolve: {
        file: function () {
          return "OK";
        },
      },
    });

    modalInstance.result.then(
      // User pressed 'Accept'
      type => {}, 
      () => {}
    );
  };

}

angular
  .module('segments.module')
  .controller('PISSegmentsController', PISSegmentsController);